/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AsControllerGetVendorWarning$Params {
  clientWorkspaceId: string;
}

export function asControllerGetVendorWarning(http: HttpClient, rootUrl: string, params: AsControllerGetVendorWarning$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'symptomCount'?: number;
'checkItemCount'?: number;
'shouldWarn'?: boolean;
'message'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, asControllerGetVendorWarning.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'symptomCount'?: number;
      'checkItemCount'?: number;
      'shouldWarn'?: boolean;
      'message'?: string;
      }>;
    })
  );
}

asControllerGetVendorWarning.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/warning';
